import { GlobalSearchResultsGroupType as ApiGlobalSearchResultsGroupType } from 'src/api/generated/touring/types';
import { mapGlobalSearchResultType } from './helpers';
import { GlobalSearchResultsGroupType } from './types';

export const mapGlobalSearchResultsGroupType = (
  apiType: ApiGlobalSearchResultsGroupType[] | undefined
): GlobalSearchResultsGroupType[] => {
  if (!apiType) return [];

  return apiType.map((apiResult) => ({
    id: apiResult.id,
    type: apiResult.type,
    results: apiResult.results.map(mapGlobalSearchResultType),
  }));
};
